// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Core__List = require("@rescript/core/src/Core__List.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var SystemMessages = require("../../systemMessages/SystemMessages.bs.js");
var AttachmentManager = require("./AttachmentManager.bs.js");
var Types__Attachment = require("../types/Types__Attachment.bs.js");

function isImage(t) {
  return t.startsWith("image/");
}

var ContentType = {
  isImage: isImage
};

function id(t) {
  var match = t.state;
  if (match.TAG === "Failed") {
    return match._0._0.id;
  } else {
    return match._0.id;
  }
}

function isImage$1(t) {
  var match = t.state;
  switch (match.TAG) {
    case "NotStarted" :
        return match._0.file.type.startsWith("image/");
    case "Failed" :
        var match$1 = match._0;
        if (match$1.TAG === "SignFailed") {
          return match$1._0.file.type.startsWith("image/");
        } else {
          return match$1._0.contentType.startsWith("image/");
        }
    case "InProgress" :
    case "Success" :
        return match._0.contentType.startsWith("image/");
    
  }
}

function fileName(t) {
  var match = t.state;
  switch (match.TAG) {
    case "NotStarted" :
        return match._0.file.name;
    case "Failed" :
        var match$1 = match._0;
        if (match$1.TAG === "SignFailed") {
          return match$1._0.file.name;
        } else {
          return match$1._0.fileName;
        }
    case "InProgress" :
    case "Success" :
        return match._0.fileName;
    
  }
}

function fromFile(file) {
  return {
          previewUrl: undefined,
          state: {
            TAG: "NotStarted",
            _0: file
          }
        };
}

function fromAttachment(attachment) {
  var previewUrl = attachment.contentType.startsWith("image/") ? Utils.makeAttachmentUrl(234, 170, false, undefined, undefined, undefined, attachment.key) : undefined;
  return {
          previewUrl: previewUrl,
          state: {
            TAG: "Success",
            _0: attachment
          }
        };
}

function isFailed(a) {
  var match = a.state;
  if (match.TAG === "Failed") {
    return true;
  } else {
    return false;
  }
}

function isInProgress(a) {
  var match = a.state;
  switch (match.TAG) {
    case "NotStarted" :
    case "InProgress" :
        return true;
    case "Failed" :
    case "Success" :
        return false;
    
  }
}

var Attachment = {
  ContentType: ContentType,
  id: id,
  isImage: isImage$1,
  fileName: fileName,
  fromFile: fromFile,
  fromAttachment: fromAttachment,
  isFailed: isFailed,
  isInProgress: isInProgress
};

function move(srcId, destId, list) {
  var src = Core__Option.getExn(Core__List.find(list, (function (x) {
              return Caml_obj.equal(srcId, id(x));
            })), undefined);
  return Core__List.reverse(Core__List.reduceWithIndex(list, /* [] */0, (function (acc, e, index) {
                    var id$1 = id(e);
                    var match = Caml_obj.equal(srcId, id$1);
                    var match$1 = Caml_obj.equal(destId, id$1);
                    if (match) {
                      if (match$1) {
                        return Core__List.add(acc, e);
                      } else {
                        return acc;
                      }
                    }
                    if (!match$1) {
                      return Core__List.add(acc, e);
                    }
                    var append = index > Core__List.length(acc);
                    if (append) {
                      return Core__List.add(Core__List.add(acc, e), src);
                    } else {
                      return Core__List.add(Core__List.add(acc, src), e);
                    }
                  })));
}

function reducer(param, action) {
  var value = param.attachments;
  var attachments;
  if (typeof action !== "object") {
    attachments = /* [] */0;
  } else {
    switch (action.TAG) {
      case "AddFiles" :
          attachments = Core__List.concat(value, Core__List.fromArray(action._0.map(fromFile)));
          break;
      case "Delete" :
          var id$1 = action._0;
          attachments = Core__List.filter(value, (function (v) {
                  return Caml_obj.notequal(id$1, id(v));
                }));
          break;
      case "PreviewComplete" :
          var url = action._1;
          var id$2 = action._0;
          attachments = Core__List.map(value, (function (v) {
                  if (Caml_obj.equal(id$2, id(v))) {
                    return {
                            previewUrl: url,
                            state: v.state
                          };
                  } else {
                    return v;
                  }
                }));
          break;
      case "Reorder" :
          attachments = move(action._0, action._1, value);
          break;
      case "Signed" :
          var attachment = action._0;
          attachments = Core__List.map(value, (function (v) {
                  var match = v.state;
                  if (match.TAG === "NotStarted" && Caml_obj.equal(match._0.id, attachment.id)) {
                    return {
                            previewUrl: v.previewUrl,
                            state: {
                              TAG: "InProgress",
                              _0: attachment,
                              _1: 0.0
                            }
                          };
                  } else {
                    return v;
                  }
                }));
          break;
      case "Progress" :
          var progress = action._1;
          var id$3 = action._0;
          attachments = Core__List.map(value, (function (v) {
                  var match = v.state;
                  if (match.TAG !== "InProgress") {
                    return v;
                  }
                  var attachment = match._0;
                  if (Caml_obj.equal(id$3, attachment.id)) {
                    return {
                            previewUrl: v.previewUrl,
                            state: {
                              TAG: "InProgress",
                              _0: attachment,
                              _1: progress
                            }
                          };
                  } else {
                    return v;
                  }
                }));
          break;
      case "UploadComplete" :
          var id$4 = action._0;
          attachments = Core__List.map(value, (function (v) {
                  var match = v.state;
                  if (match.TAG !== "InProgress") {
                    return v;
                  }
                  var attachment = match._0;
                  if (!Caml_obj.equal(id$4, attachment.id)) {
                    return v;
                  }
                  var url = v.previewUrl;
                  if (url !== undefined) {
                    URL.revokeObjectURL(url);
                  }
                  return fromAttachment(attachment);
                }));
          break;
      case "UploadError" :
          var error = action._1;
          var id$5 = action._0;
          attachments = Core__List.map(value, (function (v) {
                  var f = v.state;
                  switch (f.TAG) {
                    case "NotStarted" :
                        var f$1 = f._0;
                        if (Caml_obj.equal(f$1.id, id$5)) {
                          return {
                                  previewUrl: v.previewUrl,
                                  state: {
                                    TAG: "Failed",
                                    _0: {
                                      TAG: "SignFailed",
                                      _0: f$1,
                                      _1: error
                                    }
                                  }
                                };
                        } else {
                          return v;
                        }
                    case "InProgress" :
                        var a = f._0;
                        if (Caml_obj.equal(a.id, id$5)) {
                          return {
                                  previewUrl: v.previewUrl,
                                  state: {
                                    TAG: "Failed",
                                    _0: {
                                      TAG: "UploadFailed",
                                      _0: a,
                                      _1: error
                                    }
                                  }
                                };
                        } else {
                          return v;
                        }
                    case "Failed" :
                    case "Success" :
                        return v;
                    
                  }
                }));
          break;
      
    }
  }
  return {
          attachments: attachments
        };
}

function toAttachment(r) {
  return Types__Attachment.make(r.id, r.key, r.fileName, r.contentType);
}

function useAttachmentUploader(onChange, value) {
  var match = React.useReducer(reducer, {
        attachments: value
      });
  var reducer$1 = match[1];
  var state = match[0];
  React.useEffect((function () {
          onChange(state.attachments);
        }), [state]);
  var attachments = Core__List.toArray(state.attachments);
  var addFiles = function (files) {
    var files$1 = files.map(function (param) {
          return {
                  id: param.id,
                  file: param.file
                };
        });
    reducer$1({
          TAG: "AddFiles",
          _0: files$1
        });
  };
  var $$delete = function (id) {
    reducer$1({
          TAG: "Delete",
          _0: id
        });
  };
  var onChangePreview = function (id, url) {
    reducer$1({
          TAG: "PreviewComplete",
          _0: id,
          _1: url
        });
  };
  var reorder = function (srcId, destId) {
    reducer$1({
          TAG: "Reorder",
          _0: srcId,
          _1: destId
        });
  };
  var onUploadProgress = function (id, progress) {
    reducer$1({
          TAG: "Progress",
          _0: id,
          _1: progress
        });
  };
  var onSigned = function (attachment) {
    reducer$1({
          TAG: "Signed",
          _0: toAttachment(attachment)
        });
  };
  var onUploadComplete = function (id) {
    reducer$1({
          TAG: "UploadComplete",
          _0: id
        });
  };
  var onUploadError = function (id, error) {
    reducer$1({
          TAG: "UploadError",
          _0: id,
          _1: error
        });
  };
  var clearAll = function () {
    reducer$1("ClearAll");
  };
  return {
          addFiles: addFiles,
          attachments: attachments,
          delete: $$delete,
          onChangePreview: onChangePreview,
          onUploadProgress: onUploadProgress,
          onSigned: onSigned,
          onUploadComplete: onUploadComplete,
          onUploadError: onUploadError,
          reorder: reorder,
          clearAll: clearAll
        };
}

function makeUnsupportedFileErrorText(files) {
  var match = files.length;
  var subject = match !== 1 ? "The files" : "The file";
  var fileNames = (function (__x) {
          return Utils.$$Array.pseudoJoin(", ", " and ", __x);
        })(files.map(function (x) {
                return x.file;
              }).map(function (prim) {
              return prim.name;
            })).join("");
  var match$1 = files.length;
  var verb = match$1 !== 1 ? "are" : "is";
  return subject + " " + fileNames + " " + verb + " not supported.";
}

function useUnsupportedFilesSystemMessage() {
  var match = SystemMessages.useSystemMessages();
  var addMessage = match.addMessage;
  var makeMessage = function (files) {
    return SystemMessages.Message.make(undefined, "error", makeUnsupportedFileErrorText(files), 10000, undefined, undefined);
  };
  return function (files) {
    addMessage(makeMessage(files));
  };
}

function useAttachments(onChange, value, onUnsupportedFileError) {
  var match = useAttachmentUploader(onChange, value);
  var addFiles = AttachmentManager.useAttachmentManager(match.addFiles, match.onChangePreview, match.onUploadProgress, match.onSigned, match.onUploadComplete, match.onUploadError, onUnsupportedFileError);
  return {
          add: addFiles,
          delete: match.delete,
          attachments: match.attachments,
          reorder: match.reorder,
          clearAll: match.clearAll
        };
}

exports.Attachment = Attachment;
exports.move = move;
exports.reducer = reducer;
exports.toAttachment = toAttachment;
exports.useAttachmentUploader = useAttachmentUploader;
exports.makeUnsupportedFileErrorText = makeUnsupportedFileErrorText;
exports.useUnsupportedFilesSystemMessage = useUnsupportedFilesSystemMessage;
exports.useAttachments = useAttachments;
/* Utils Not a pure module */
